/**
 * Parse API datetime strings as UTC.
 *
 * Backend stores UTC in naive columns and often serializes without a zone suffix.
 * ECMAScript treats zone-less ISO datetimes as local time, which skews "time ago"
 * displays by the user's UTC offset.
 */
export function parseApiDate(iso) {
  if (iso == null || iso === '') return null;
  if (iso instanceof Date) return iso;
  if (typeof iso !== 'string') return new Date(iso);

  const normalized = iso.trim().replace(' ', 'T');
  if (/Z$/i.test(normalized)) return new Date(normalized);
  if (/[+-]\d{2}:\d{2}$/.test(normalized)) return new Date(normalized);
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(normalized)) {
    return new Date(`${normalized}Z`);
  }
  return new Date(normalized);
}
